import React, { useState, useEffect } from "react";
import api from "../../utils/api.utils";
import { useParams } from "react-router-dom";
import { NavbarAdmin } from "../../components/NavbarAdmin";
import { FooterAdmin } from "../../components/FooterAdmin";

import "../css/AdminHome.css";
export const CategoriasOuvidorias = ({ loading, setLoading, loadingGif }) => {
  const { categoria } = useParams();
  let newCategoria = categoria;
  if (categoria === "elogios") {
    newCategoria = "Elogios";
  }
  if (categoria === "reclamacoes") {
    newCategoria = "Reclamações";
  }
  if (categoria === "sugestoes") {
    newCategoria = "Sugestão";
  }
  if (categoria === "outros") {
    newCategoria = "Outros";
  }

  const [ouvidorias, setOuvidorias] = useState([]);

  useEffect(() => {
    const getOuvidorias = async () => {
      try {
        const data = await api.getOuvidorias();
        const orderedList = [...data].sort(
          (a, b) => b.protocolo_id - a.protocolo_id
        );
        setOuvidorias(orderedList);
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      } catch (error) {
        console.log(error, "Error to get Ouvidorias");
      }
    };
    getOuvidorias();
  }, [loading, setLoading]);

  return (
    <div>
      <NavbarAdmin />
      <div className="container mt-3">
        <h4>Manifestações de {newCategoria}</h4>
      </div>
      <hr />
      <div className="container">
        <table className="table table-hover">
          <thead>
            <tr>
              <th scope="col">Data</th>
              <th scope="col">Protocolo</th>
              <th scope="col" className="no-mobile">
                Categoria
              </th>
              <th scope="col" className="no-mobile">
                Reclamante
              </th>
              <th scope="col">Status</th>
            </tr>
          </thead>
          <tbody>
            {!loading ? (
              ouvidorias.map((ouvidoria, index) => {
                let anoOuv = ouvidoria.createdAt.slice(0, 4);
                if (ouvidoria.tipo === categoria) {
                  return (
                    <tr key={index}>
                      <td>
                        {new Intl.DateTimeFormat("default", {
                          timeZone: "America/Sao_Paulo",
                          year: "numeric",
                          month: "2-digit",
                          day: "2-digit",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: false,
                        }).format(new Date(ouvidoria.createdAt))}
                        h
                      </td>
                      <td>
                        <b>
                          {anoOuv}OUV{ouvidoria.protocolo_id}
                        </b>
                      </td>
                      <td className="no-mobile">{newCategoria}</td>
                      <td className="no-mobile">
                        {ouvidoria.name.toUpperCase() || "ANÔNIMO"}
                      </td>
                      <td>
                        {ouvidoria.status[0].toUpperCase() +
                          ouvidoria.status.substring(1).replaceAll("-", " ")}
                      </td>
                    </tr>
                  );
                }
                return "";
              })
            ) : (
              <tr>
                <td colSpan="8" className="text-center">
                  <img
                    style={{ width: "100px" }}
                    src={loadingGif}
                    alt="Loading gif"
                  />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <FooterAdmin />
    </div>
  );
};
